export default __webpack_public_path__ + "2b762994f43bfad7ccb785e19c732b97.png";